import { IEntityContent } from './Common';

// eslint-disable-next-line no-shadow
export enum IQuizQuestionTypes {
	OPTIONS = 1,
	MULTIPLE_OPTIONS = 2,
	EXACT_ANSWER = 3,
}

// eslint-disable-next-line no-shadow
export enum IQuizTypes {
	QUIZ = 1,
	EXAM = 2,
}

export interface IQuizOption {
	text: string;
	id: string;
}

export interface IQuizQuestion {
	id: string;
	text: string;
	type: number;
	answer?: string[];
	options?: IQuizOption[];
}

/* export interface QuizContent {
	[key: string]: {
		name: string;
		description: string;
		questions: QuizQuestion[];
	};
} */

export interface QuizDTO {
	name: string;
	type: IQuizTypes;
	content: IEntityContent;
}

export interface IQuiz {
	id: number;
	name: string;
	slug: string;
	type: IQuizTypes;
	content: IEntityContent;
}

export interface QuizLightRO {
	id: number;
	name: string;
	slug: string;
}
